import { fork, all } from 'redux-saga/effects';
import checkoutComponentSagas from 'yoda-checkout-components/lib/sagas';
import watchProductDetailsSaga from 'yoda-site-components/lib/sagas/ProductDetailsSaga';
import watchcartItemUpdateSaga from 'yoda-checkout-components/lib/sagas/CartItemUpdateSaga';
import watchSelectStore from 'yoda-site-components/lib/sagas/SelectStoreSaga';
import {
    watchApplyAdjustmentsRequest,
    watchRemoveAdjustmentsRequest,
    watchgetAppliedAdjustmentsRequest,
    watchgetEmptyAdjustmentsRequest,
} from 'yoda-site-components/lib/sagas/AdjustmentSaga';
import watchSYFQuickScreenSaga from 'yoda-account-components/lib/sagas/SYFQuickScreenSaga';
import watchPlccDynamicBannerSaga from 'yoda-site-components/lib/sagas/PlccDynamicBannerSaga';
import watchCartDetails from './CartDetailsSaga';
import watchGiftCard from './GiftCardSaga';
import watchRemoveCartItem from './RemoveCartItemSaga';
import watchSaveForLater from './SaveForLaterSaga';
import watchItemQuantityUpdate from './ItemQuantityUpdateSaga';
import watchItemFulfillmentUpdate from './ItemFulfillmentUpdateSaga';
import watchRemoveSavedItem from './RemoveSavedItemSaga';
import watchGiftCardBannerSaga from './GiftCardBannerSaga';
import watchMarketingSlotBannerRequest from './MarketingSlotBannerSaga';
import watchSingleClickCheckoutSessionInitSaga from './SingleClickCheckoutSaga';
import watchSavedItemsProductListRequest from './SavedItemsSaga';
import watchRewardsPointsEarned from './RewardsPointsEarnedSaga';

const checkoutComponentSagaList = Object.values(checkoutComponentSagas.injectedSagas);
const productSagas = [
    /**
     * Why is it added here? Action triggered by:
     * src/components/SingleClickCheckoutWrapper.jsx component
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx component
     * src/containers/Pages/SignIn/SignInPage.jsx component
     * src/components/EmptyCart/EmptyCart.jsx component
     * src/sagas/ItemFulfillmentUpdateSaga.js saga
     * src/sagas/ItemQuantityUpdateSaga.js saga
     * src/sagas/RemoveCartItemSaga.js saga
     */
    watchCartDetails,
    /**
     * Why is it added here? Action triggered by:
     * src/containers/Pages/GiftCard/GiftCardBalance.jsx component
     */
    watchGiftCard,
    watchProductDetailsSaga,
    watchcartItemUpdateSaga,
    /**
     * Why is it added here? Action triggered by:
     * src/components/RemoveItem/RemoveItem.jsx component
     * src/sagas/SaveForLaterSaga.js saga
     */
    watchRemoveCartItem,
    /**
     * Why is it added here? Action triggered by:
     * src/components/CartItem/CartItem.jsx component
     */
    watchSaveForLater,
    /**
     * Why is it added here? Action triggered by:
     * src/components/CartItem/CartItem.jsx component
     */
    watchItemQuantityUpdate,
    /**
     * Why is it added here? Action triggered by:
     * src/components/ItemFulfillmentsNew/ShipToHomeOrBopisOption/ShipToHomeOrBopisOption.jsx component
     */
    watchItemFulfillmentUpdate,
    /**
     * Why is it added here? Action triggered by:
     * src/components/SavedItem/SavedItem.jsx component. Can be moved to yoda-checkout-components
     */
    watchRemoveSavedItem,
    /**
     * Why is it added here? Action triggered by:
     * src/components/EarnRewardsPoints/EarnRewardsPoints.jsx component.
     */
    watchRewardsPointsEarned,
    /**
     * Why is it added here? Action triggered by:
     * src/components/GiftCardBanner/GiftCardBanner.jsx component
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx component
     */
    watchGiftCardBannerSaga,
    /**
     * Why is it added here? Action triggered by:
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx component
     */
    watchMarketingSlotBannerRequest,
    /**
     * Why is it added here? Action triggered by:
     * src/components/PLCCDynamicBanner/PLCCDynamicBanner.jsx component
     * src/components/PLCCDynamicBanner/PLCCDynamicBanner.jsx component
     */
    watchPlccDynamicBannerSaga,
    /**
     * Why is it added here? Action triggered by:
     * yoda-checkout-components/src/components/OrderSummary/OrderSummaryCTA.jsx
     * --> yoda-checkout-components/src/components/OrderSummary/OrderSummary.jsx
     * ---> src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx component
     */
    watchSingleClickCheckoutSessionInitSaga,
    /**
     * Why is it added here? Action triggered by:
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx component
     */
    /**
     * Cart - saved item update
     * yoda-microsite-cart/src/components/SavedItemsList/SavedItemsList.jsx
     * yoda-microsite-cart/src/sagas/RemoveCartItemSaga.js
     * yoda-microsite-cart/src/sagas/RemoveSavedItemSaga.js
     */
    watchSavedItemsProductListRequest,
    /**
     * cart, pdp, checkout - find store component
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/ShowDetailedFulfillments/ShowDetailedFulfillments.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     */
    watchSelectStore,
    /**
     * coupon, cart, checkout, header/footer - coupon application
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchApplyAdjustmentsRequest,
    /**
     * coupon, cart, checkout, header/footer - coupon application
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchRemoveAdjustmentsRequest,
    /**
     * coupon, cart, checkout, header/footer - coupon get
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchgetAppliedAdjustmentsRequest,
    /**
     * coupon, cart, checkout, header/footer - coupon application
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchgetEmptyAdjustmentsRequest,
    watchSYFQuickScreenSaga,
    /**
     * To update store infomation to location service saga
     * node_modules/yoda-site-components/lib/sagas/SelectStoreSaga.js
     */
    ...checkoutComponentSagaList,
];

const injectedSagas = {};
for (const saga of productSagas) { // eslint-disable-line
    // 1. Check that every saga has a name
    if (!saga.sagaName) {
        throw new Error(
            `Every saga has to have sagaName property. For debug purposes: ${saga.toString()}`
        );
    }

    // 2. Check that we have only unique sagas (one could be from components, another the same one from shared)
    if (injectedSagas[saga.sagaName]) {
        throw new Error(
            `That saga ${saga.sagaName} was already registered. Only 1 instance for particular name is allowed`
        );
    }
    injectedSagas[saga.sagaName] = saga;
}

const productRootSaga = function* productRootSaga() {
    yield all(Object.values(injectedSagas).map((saga) => fork(saga)));
};

productRootSaga.injectedSagas = injectedSagas;

export default productRootSaga;
